import { onScroll } from 'animejs';

class Module03Podcast {
	constructor() {
		let cache = {};
		let initFunc = () => {
			initCache();
			registerEvents();
		};

		let initCache = () => {
			cache.podcastModules = document.querySelectorAll(".module-03-podcast");
		};

		let registerEvents = () => {
			cache.podcastModules.forEach((module) => {
				const images = module.querySelectorAll(".podcast-image");
				const contents = module.querySelectorAll(".podcast-content");

				function activateElement(index) {
					images.forEach((img) => img.classList.remove("active"));
					contents.forEach((content) => content.classList.remove("active"));

					if (images[index]) images[index].classList.add("active");
					if (contents[index]) contents[index].classList.add("active");
				}

				activateElement(0);

				images.forEach((image, index) => {
					if (!image.dataset.index) {
						image.dataset.index = index.toString();
					}

					onScroll({
						target: image,
						axis: 'y',
						enter: 'bottom-=35% top+=20%',
						leave: 'top+=20% bottom-=60%',
						repeat: true,
						onEnter: () => {
							activateElement(parseInt(image.dataset.index));
						}
					});
				});
			});
		};

		initFunc();
	}
}
export { Module03Podcast };